export const APP_NAME = '@SkybarMenu';
export const WEB_AUTH_TOKEN = 'GENESIS-SKYBAR-TOKEN'
